import { PassHolderFormState } from "@/types/PassHolder"
import { SelectedProduct } from "@/types/Product"

export const createInitialPassHolders = (
  selectedProducts: SelectedProduct[]
): PassHolderFormState[] => {
  const passHolders: PassHolderFormState[] = []
  let passHolderId = 1

  selectedProducts.forEach((product) => {
    for (let i = 0; i < product.quantity; i++) {
      passHolders.push({
        id: `${passHolderId}`,
        productPriceId: product.productPriceId,
        passHolder: {
          id: `${passHolderId}`,
          firstName: "",
          lastName: "",
          birthDate: "",
        },
        productName: product.productName,
        productId: product.productId,
        resortId: product.resortId,
        ageGroup: product.ageGroup,
        minAge: product.minAge,
        maxAge: product.maxAge,
        wtpNumber: "",
        insurance: undefined,
        passSelection: null,
        isSubscriptionProduct: product.isSubscriptionProduct,
        isFormSubmitted: false,
        idImageRequired: product.idImageRequired,
        personCertificateRequired: product.personCertificateRequired,
        bookingLengthInDays: product.bookingLengthInDays,
        showFreeSkiDays: product.showFreeSkiDays,
        subscriptionConfigurationId: product.subscriptionConfigurationId,
        analyticsName: product.analyticsName,
        analyticsId: product.analyticsId,
      })
      passHolderId++
    }
  })

  return passHolders
}
